/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css'; // Ensure AOS CSS is imported
import Breadcrumbs from '../../layout/Breadcrumbs';
import { useLocation } from "react-router-dom";

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



// Function to copy text and show a toast notification



function Contact({ showBreadcrumbs = true , showHeader = false}) {
  // Initialize AOS (if not already done at a global level)
  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 50,
      easing: 'ease-in-out',
      once: false,
    });
  }, []);


  const copyToClipboard = (text) => {
    debugger
    if (navigator.clipboard && window.isSecureContext) {
      // Modern method
      navigator.clipboard.writeText(text)
        .then(() => {
          toast.success(`Copied: ${text}`, { position: "top-right", autoClose: 2000 });
        })
        .catch((err) => {
          console.error('Clipboard error:', err);
          fallbackCopy(text);
        });
    } else {
      // Fallback for non-HTTPS or older browsers
      fallbackCopy(text);
    }
  };
  
  const fallbackCopy = (text) => {
    debugger
    try {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      // Avoid scrolling to bottom
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
  
      const successful = document.execCommand('copy');
      document.body.removeChild(textArea);
  
      if (successful) {
        toast.success(`Copied: ${text}`, { position: "top-right", autoClose: 2000 });
      } else {
        toast.error("❌ Failed to copy!");
      }
    } catch (err) {
      console.error('Fallback copy error:', err);
      toast.error("❌ Failed to copy!");
    }
  };

  
  
  // React state for form fields
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [comments, setComments] = useState('');
  const location = useLocation();
  const [submittedData, setSubmittedData] = useState(null);

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   const formData = { username, email, subject, comments };
  //   setSubmittedData(formData);
  //   setUsername('');
  //   setEmail('');
  //   setSubject('');
  //   setComments('');
  //   toast.success("✅ Your message has been sent!");
  // };
  const handleSubmit = async (e) => {
    debugger;
    e.preventDefault();
    const formData = {
    fullName: username,
    email: email,
    subject: subject,
    comments: comments,
    };
    try {
    const response = await fetch("https://apitest.spadez.co/api/contact/contact", {
    method: "POST",
    headers: {
    "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
    });
    const result = await response.json();
    if (response.ok) {
    toast.success("✅ Your message has been sent!");
    setSubmittedData(formData);
    setUsername('');
    setEmail('');
    setSubject('');
    setComments('');
    } else {
    toast.error(`❌ Failed: ${result.message || "Something went wrong"}`);
    }
    } catch (error) {
    console.error("Error:", error);
    toast.error("❌ Server Error: Could not send message");
    }
    };
  return (
    <>
    {/* Conditionally render Breadcrumbs */}
    {showBreadcrumbs && location.pathname === "/contact" && (
      <Breadcrumbs
         pageTitle="Contact Us"
         pageSubtitle="We provide solutions to help your business grow."
        activePage="Contact Us"
      />
    )}

    <div className="contact-us" id="contact-us">
      {/* Header Section */}
      {showHeader && (
      <div className="header pb-4 pb-md-auto" data-aos="fade-up" data-aos-delay="100">
        <div className="title">Contact Us</div>
        <p className="para">Get in touch with us for any inquiries or support.</p>
      </div>
     )}

      <div className="container">
      
        <div className="row">
        
          {/* Left Column: Address, Phone, Email */}
          <div className="col-lg-4 col-sm-12" data-aos="fade-up" data-aos-delay="400">
            <div className="address mb-4">
              <h5>Address:</h5>
              <p
                className="text-black-60 fw-normal"
                style={{ fontSize: '15px' }}
              >
                Spadez Solutions Pvt. Ltd.
                <br />
                E-96, Industrial Area, Phase – 8, Mohali – 160062, Punjab.
              </p>
            </div>
            <div className="phone mb-4">
              <h5>Phone:</h5>
              <ul className="list-unstyled">
                {/* <li className="text-black-60 fw-normal">
                  +91 <a href="tel:9876561364">9876561364</a>
                </li>
                <li className="text-black-60 fw-normal">
                  +91 <a href="tel:9876953067">9876953067</a>
                </li>
                <li className="text-black-60 fw-normal">
                  +91 <a href="tel:9501684016">9501684016</a>
                </li> */}
                <li className="text-black-60 fw-normal">
                  +91 <a href="tel:9501684016">172 466 4601</a>
                </li>
              </ul>
            </div>
            <div className="phone mb-4">
              <h5>LinkedIn:</h5>
               <a target='_blank' href=" https://in.linkedin.com/company/spadez-solutions-priv-limited">
               Spadez Solutions Private Limited
              </a>
              <span onClick={() => copyToClipboard("https://in.linkedin.com/company/spadez-solutions-priv-limited")}  style={{ cursor: "pointer", marginLeft: "10px", pointerEvents: "auto" }} >
                    <i className="fab fa-linkedin"></i> 
                </span>
            </div>
            <div className="email mb-4 mb-md-0">
              <h5>Email:</h5>
            
              <ul className="list-unstyled fw-normal">
                  <li>
                    <a href="mailto:info@spadezgroup.com">info@spadezgroup.com</a>
                    <span
                      onClick={() => copyToClipboard("info@spadezgroup.com")}
                      style={{ cursor: "pointer", marginLeft: "10px", pointerEvents: "auto" }}
                    >
                      <i className="fas fa-copy"></i>
                    </span>
                  </li>
                  <li>
                    <a href="mailto:careers@spadezgroup.com">careers@spadezgroup.com</a>
                    <span
                      onClick={() => copyToClipboard("careers@spadezgroup.com")}
                      style={{ cursor: "pointer", marginLeft: "10px", pointerEvents: "auto" }}
                    >
                      <i className="fas fa-copy"></i>
                    </span>
                  </li>
                  <li>
                    <a href="mailto:fin@spadezgroup.com">fin@spadezgroup.com</a>
                    <span
                      onClick={() => copyToClipboard("fin@spadezgroup.com")}
                      style={{ cursor: "pointer", marginLeft: "10px", pointerEvents: "auto" }}
                    >
                      <i className="fas fa-copy"></i>
                    </span>
                  </li>
                  {/* <li>
                    <a href="mailto:jay.chauhan@spadezgroup.com">jay.chauhan@spadezgroup.com</a>
                    <span
                      onClick={() => copyToClipboard("jay.chauhan@spadezgroup.com")}
                      style={{ cursor: "pointer", marginLeft: "10px", pointerEvents: "auto" }}
                    >
                      <i className="fas fa-copy"></i>
                    </span>
                  </li>
                  <li>
                    <a href="mailto:pankaj.sadiyal@spadezgroup.com">pankaj.sadiyal@spadezgroup.com</a>
                    <span
                      onClick={() => copyToClipboard("pankaj.sadiyal@spadezgroup.com")}
                      style={{ cursor: "pointer", marginLeft: "10px", pointerEvents: "auto" }}
                    >
                      <i className="fas fa-copy"></i>
                    </span>
                  </li> */}
                </ul>

                <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar={false} />
            </div>
          </div>

          {/* Right Column: Contact Form */}
          <div className="col-lg-8 col-sm-12">
            <form id="contact-form" onSubmit={handleSubmit}>
              <div className="row">
                {/* Username Field */}
                <div className="col-lg-6 col-sm-12 mb-3" data-aos="fade-up" data-aos-delay="100">
                  <div className="input-group has-validation">
                    <div className="form-floating flex-grow-1">
                      <input
                        type="text"
                        className="form-control"
                        id="floatingInputGroup1"
                        placeholder="Name"
                        required
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                      />
                      <label htmlFor="floatingInputGroup1">Name</label>
                    </div>
                  </div>
                </div>

                {/* Email Field */}
                <div className="col-lg-6 col-sm-12 mb-3" data-aos="fade-up" data-aos-delay="400">
                  <div className="input-group has-validation">
                    <div className="form-floating flex-grow-1">
                      <input
                        type="email"
                        className="form-control"
                        id="floatingInputGroup2"
                        placeholder="Email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <label htmlFor="floatingInputGroup2">Email</label>
                    </div>
                  </div>
                </div>

                {/* Subject Field */}
                <div
                  className="form-floating col-lg-12 mb-3 flex-grow-1"
                  data-aos="fade-up"
                  data-aos-delay="800"
                >
                  <input
                    type="text"
                    className="form-control"
                    id="floatingSubject"
                    placeholder="Subject"
                    required
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                  />
                  <label htmlFor="floatingSubject" className="ps-4">
                    Subject
                  </label>
                </div>

                {/* Comments Field */}
                <div className="col-lg-12 mb-3" data-aos="fade-up" data-aos-delay="1000">
                  <div className="form-floating">
                    <textarea
                      className="form-control"
                      placeholder="Leave a comment here"
                      id="floatingTextarea2"
                      style={{ height: '200px' }}
                      required
                      value={comments}
                      onChange={(e) => setComments(e.target.value)}
                    />
                    <label htmlFor="floatingTextarea2">Comments</label>
                  </div>
                </div>

                {/* Submit Button */}
                <div className="col-lg-8 col-md-12" data-aos="fade-up" data-aos-delay="700">
                  <button type="submit" className="btn btn-primary">
                    Send Message
                  </button>
                </div>
              </div>
            </form>

            {/* Optional: Display submitted data */}
            {submittedData && (
              <div className="mt-4 alert alert-success">
              <h4 className="mb-2">Thank You for Reaching Out!</h4>
              <p>We’ve received your message and will be in touch with you shortly.</p>
                {/* <p><strong>Name:</strong> {submittedData.username}</p>
                <p><strong>Email:</strong> {submittedData.email}</p>
                <p><strong>Subject:</strong> {submittedData.subject}</p>
                <p><strong>Message:</strong> {submittedData.comments}</p>
                <p className="mt-3">📩 Check your email for confirmation.</p> */}
              </div>
            
            )}
          </div>
        </div>
      </div>
    </div>
    {(location.pathname === "/contact" || location.pathname === "/") && (
    <div className="company-location">
      <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3430.3835742767!2d76.7011312742645!3d30.707615386848406!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390feef6bde3ac57%3A0xa4d65d2927529ba4!2sSpadez%20Solutions%20Private%20Limited!5e0!3m2!1sen!2sin!4v1740661417276!5m2!1sen!2sin"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen={true}
          referrerPolicy="no-referrer-when-downgrade"
          loading="lazy"></iframe>
      </div>
      )}
    </>
  );
}

export default Contact;
